import { IGetAllInspecaoObraOcorrenciaUseCase } from "../../../presentation/useCases/read/get_all_inspecao_obra_ocorrencia_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { InspecaoObraOcorrencia } from "../../models/inspecao_obra_ocorrencia";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetAllInspecaoObraOcorrenciaUseCase
 */

export class GetAllInspecaoObraOcorrenciaUseCase
  extends BasePaginatedUseCase<InspecaoObraOcorrencia>
  implements IGetAllInspecaoObraOcorrenciaUseCase {
  constructor(private readonly repository: IObrasRepository) {
    super();
  }

  async getAllInspecaoObraOcorrencia(
    idInspecaoObra: number | undefined,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    if (idInspecaoObra === undefined) throw new Error('Id de inspeção obra invalido!');

    const response = await this.repository.getAllInspecaoObraOcorrencia(
      idInspecaoObra,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
